import {
    BackButton, BoxNumberSelection,
    BoxTypeSelection, BoxTypeSelectionResult,
    layout, useStorageItemValue,
    View,
    ViewContent,
    ViewDescription,
    ViewHeader,
    ViewHeaderItem,
    ViewTitle
} from "@variocube/cube-ui";
import * as React from "react";
import {commonStyles} from "./commonStyles";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";
import {Account} from "./model";

interface SizeSelectionViewProps {
    onBack: () => void;
    sizes: ReadonlyArray<string>;
    onTypeSelect: (result: BoxTypeSelectionResult) => void;
    onNumberSelect: (boxNumber: string) => void;
    recipient?: Account;
}

export function BoxSelectionView({onBack, onNumberSelect, onTypeSelect, sizes, recipient}: SizeSelectionViewProps) {
    const {t} = useLocalization();
    const directBoxSelection = useStorageItemValue<boolean>("directBoxSelection");

    return (
        <View>
            <ViewHeader className={commonStyles.viewHeader}>
                <ViewHeaderItem>
                    <BackButton onClick={onBack} label={t("Back")}/>
                </ViewHeaderItem>
                <ViewHeaderItem fill>
                    <ViewTitle>{directBoxSelection ? t('SelectNumberTitle') : t("SelectSizeTitle")}</ViewTitle>
                    <ViewDescription>{directBoxSelection ? t('SelectNumberDescription') : t("SelectSizeDescription")}</ViewDescription>
                </ViewHeaderItem>
            </ViewHeader>
            <ViewContent className={styles.viewContent}>
                {directBoxSelection === true && (
                    <BoxNumberSelection
                        onSelect={onNumberSelect}
                        className={layout.fill}
                    />
                )}
                {directBoxSelection === false && (
                    <BoxTypeSelection
                        types={sizes}
                        onSelect={onTypeSelect}
                        className={layout.fill}
                        strings={t}
                        features={(recipient && recipient.specialNeeds) ? ['accessible'] : []}
                    />
                )}
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    viewContent: {
        display: "flex"
    }
});
